
import { Options, prop, Vue } from 'vue-class-component';

class Props {
  unassigned = prop<number>({
    default: 0
  });
}

@Options({
  emits: ["onAdjustArea", "onViewArea"],
  components: {}
})
class EmptyState extends Vue.with(Props) {
  get isNoArea() {
    return this.unassigned === 0;
  }

  get headerMessage() {
    return this.isNoArea
      ? this.$t("pickupDashboard.manageArea.emptyHeader")
      : this.$t("pickupDashboard.manageArea.emptyHeaderWithUnassigned");
  }

  get message() {
    return this.isNoArea
      ? this.$t("pickupDashboard.manageArea.emptyMessage")
      : this.$t("pickupDashboard.manageArea.emptyMessageWithUnassigned");
  }
}

export default EmptyState;
